import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import bg from '../img/hets-logo.png';
import bg2 from '../img/hets-logo-long.png';
import Login from '../widgets/login';


export default function Iphone() {

  const [opac, setOpac] = useState(false);
  const [opac2, setOpac2] = useState(false);
  const [hideme, setHideme] = useState(false);
  const [next, setNext] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setOpac(true)
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpac2(true)
    }, 800);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHideme(true)
    }, 3000);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setNext(true);
    }, 3500);
    return () => clearTimeout(timer);
  }, []);

  return (<><Wrap>
    <PhoneWrapper>
      <IMMG src="https://www.uokpl.rs/fpng/f/405-4057345_iphone-11-png.png" />
      <Content>
        {!next
          ? <>
            <ImgWrap opac={hideme}>
              <Img src={bg} opac={opac} />
              <Version opac={opac2}>Version 1.00</Version>
              <Version opac={opac2}>&copy;2020</Version>
            </ImgWrap>
          </>
          :
          <ImgWrap2>
            <Img2 src={bg2} />
            <Login />
          </ImgWrap2>
        }
      </Content>
      <HideNook></HideNook>
    </PhoneWrapper>

  </Wrap>
  </>)
}
const Img = styled.img`
  transition: opacity 0.3s linear;
  opacity: ${({ opac }) => opac ? "1" : "0"};
`;
const ImgWrap2 = styled.div`
  margin-top: 50px;
  transition: all 0.3s linear;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
      & img {
    width: 200px;
    height: auto;
  }
`;
const Img2 = styled.img`
`;

const Version = styled.div`
  transition: opacity 0.4s linear;
  opacity: ${({ opac }) => opac ? "1" : "0"};
  font-size: 12px;
  font-family: Work sans, san-serif;
  color: #48556A;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const Wrap = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px auto;
`;
const PhoneWrapper = styled.div`
  width: calc(414px / 1.5);
  height: calc(896px / 1.5);
  position: relative;
`;

const IMMG = styled.img`
  width: 100%;
`;

const Content = styled.div`
  position: absolute;
  background: radial-gradient(#ffffff, #E8F0F7);
  top: 17px;
  left: 19px;
  width: 229px;
  height: 489px;
  border-radius: 25px;
  z-index: 1;
  padding: 20px 5px 10px;
  overflow: hidden;
`;
const ImgWrap = styled.div`
  transition: opacity 0.3s linear;
  opacity: ${({ opac }) => opac ? "0" : "1"};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 150px;
  align-items: center;
    & img {
    width: 180px;
    height: auto;
    padding-bottom: 105px;
  }
`;

const HideNook = styled.div`
  position: absolute;
  background-color: black;
  z-index: 2;
  top: 14px;
  left: 50%;
  width: 135px;
  height: 22px;
  transform: translateX(-50%);
  border-bottom-left-radius: 13px;
  border-bottom-right-radius: 13px;
`;